import { render, staticRenderFns } from "./StudentFormFields.vue?vue&type=template&id=081f7f3e"
import script from "./StudentFormFields.vue?vue&type=script&lang=js"
export * from "./StudentFormFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports